






































import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import {
    SdsDividerLine,
    SdsIllustration,
    SdsToggleSwitch,
    SanitizedHtml,
} from '@superbet-group/web.lib.ui-components';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';
import {
    useVuexStore,
    isMobileLayout,
} from '@superbet-group/web.lib.vue-utilities';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import { authenticationService } from '@core/services/authentication/AuthenticationService';
import { SendMfaCodePayload } from '@core/services/authentication/_private/Types';

enum MfaPurpose {
    DisableMfa = 'disablemfa',
    Email = 'email',
}

export default defineComponent({
    name: 'AccountSecurityBanner',
    setup() {
        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');

        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const user = authModule.getter('user');
        const setUserData = authModule.action('setUserData');
        const isMfaPreferenceEnabled = computed(() => !!user.value?.isMfaPreferenceEnabled);
        const purpose = computed(() => user.value!.isMfaPreferenceEnabled ? MfaPurpose.DisableMfa : MfaPurpose.Email);

        const onSuccess = () => {
            setModal({
                code: modalCodes.mfaPreferenceStatus,
                data: {
                    title: !user.value?.isMfaPreferenceEnabled ? 'pam.security.mfaStatusModal.mfaEnabledTitle' : 'pam.security.mfaStatusModal.mfaDisabledTitle',
                    subtitle: !user.value?.isMfaPreferenceEnabled ? 'pam.security.mfaStatusModal.mfaEnabledSubtitle' : 'pam.security.mfaStatusModal.mfaDisabledSubtitle',
                    illustrationName: 'password-success',
                },
            });
            setUserData({
                key: 'isMfaPreferenceEnabled',
                value: !user.value?.isMfaPreferenceEnabled,
            });
        };

        async function setMfaOtpCodeModal() {
            const mfaPayload: SendMfaCodePayload = {
                playerId: user.value!.userId,
                secureToken: user.value!.sessionId.split('|')[0],
                purpose: purpose.value,
            };

            await authenticationService.sendOtpCode(mfaPayload);

            setModal({
                code: modalCodes.mfaPreferenceOtp,
                data: {
                    onSuccess,
                },
            });
        }

        async function toggleMFA() {
            if (isMfaPreferenceEnabled.value) {
                setModal({
                    code: modalCodes.disableMfaPreference,
                    data: {
                        callOnComplete: () => setMfaOtpCodeModal(),
                    },
                });
            } else {
                await setMfaOtpCodeModal();
            }
        }

        return {
            toggleMFA,
            isMfaPreferenceEnabled,
            isMobile: computed(() => isMobileLayout()),
        };
    },
    components: {
        SanitizedHtml,
        SdsDividerLine,
        SdsIllustration,
        SdsToggleSwitch,
    },
});
